<template>
    <div class="version-selection dst">
        <template v-if="trims.length">
            <h2 class="version-selection__trims-title tw-text-center tw-font-bold headline-md">
                {{ $t('configuration-wizard.trims') }}
            </h2>
            <dk-slider-dst
                class="version-selection__trim-slider tw-mt-6 lg:tw-mt-10 lg:tw-mx-8"
                :class="{ 'max-lg:tw-mx-6': hasOneTrim }"
                :swiper-opts="trimsSwiperOptions"
                are-bullets-disabled
                :are-buttons-visible="trims.length > 4"
                @ready="handleTrimSwiperInit"
            >
                <dk-slide v-for="(trim, index) in trims" :key="index">
                    <dk-configuration-trim-card
                        v-bind="trim"
                        :is-selected="trim.id === selectedTrim.id"
                        @click="onTrimClick"
                    />
                </dk-slide>
            </dk-slider-dst>
        </template>
        <div v-if="selectedTrim && selectedTrim.versions && selectedTrim.versions.length && isTrimsSliderInitialized">
            <h2 class="version-selection__versions-title tw-text-center tw-font-bold headline-md tw-mt-8 lg:tw-mt-14">
                {{ $t('configuration-wizard.engines') }}
            </h2>
            <dk-slider-dst
                class="version-selection__versions-slider dst tw-mx-6 lg:tw-mx-8 tw-mt-6 lg:tw-mt-10"
                :swiper-opts="versionsSwiperOptions"
                are-bullets-disabled
                :are-buttons-visible="selectedTrim.versions.length > 3"
            >
                <dk-slide v-for="version in selectedTrim.versions" :key="version.id">
                    <dk-configuration-engine-card
                        v-bind="version"
                        :is-selected="version.versionId === selectedVersion.versionId"
                        @click="onVersionClick"
                    />
                </dk-slide>
            </dk-slider-dst>
        </div>
    </div>
</template>

<script>
/*
 * An optional selection component
 */
export default {
    name: 'VersionSelection',
    components: {
        DkConfigurationEngineCard: () => ({
            component: import(
                /* webpackChunkName: "DkConfigurationEngineCard.vue-vue" */ '@v4/configuration-wizard/components/atoms/VersionCard/DkConfigurationEngineCard.vue'
            ),
        }),
        DkConfigurationTrimCard: () => ({
            component: import(
                /* webpackChunkName: "DkConfigurationTrimCard-vue" */ '@v4/configuration-wizard/components/atoms/TrimCard/DkConfigurationTrimCard.vue'
            ),
        }),
        DkSlide: () => ({
            component: import(/* webpackChunkName: "DkSlide-vue" */ '@v4/common/components/atoms/DkSlide'),
        }),
        DkSliderDst: () => ({
            component: import(
                /* webpackChunkName: "DkSliderDST-vue" */ '@v4/common/components/molecules/DkSliderDST.vue'
            ),
        }),
    },
    props: {
        /*
         * All trims
         */
        trims: {
            type: Array,
            default: () => [],
        },
        /*
         * Selected version
         */
        selectedVersion: {
            type: Object,
            default: () => ({}),
        },
        /*
         * Selected trim
         */
        selectedTrim: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            commonSwiperOptions: {
                spaceBetween: 16,
                breakpointsInverse: true,
                watchOverflow: true,
                noSwiping: false,
                breakpoints: {
                    767: {
                        slidesPerView: 3,
                    },
                },
            },
            isTrimsSliderInitialized: false,
        };
    },
    computed: {
        hasOneTrim() {
            return this.trims && this.trims.length === 1;
        },
        trimsSwiperOptions() {
            return {
                ...this.commonSwiperOptions,
                slidesPerView: this.hasOneTrim ? 1 : 1.28,
                slidesOffsetBefore: this.hasOneTrim ? 0 : 24,
                slidesOffsetAfter: this.hasOneTrim ? 0 : 24,
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    },
                },
            };
        },
        versionsSwiperOptions() {
            return {
                ...this.commonSwiperOptions,
                slidesPerView: 1,
            };
        },
    },
    methods: {
        handleTrimSwiperInit() {
            this.isTrimsSliderInitialized = true;
        },
        onVersionClick({ versionId }) {
            /**
             * Fired when clicked on the version item
             *
             * @event click
             * @type {object}
             * @property {object} $event - Click event
             * @property {object} id - Item versionId
             */
            this.$emit('version-click', versionId);
        },
        onTrimClick({ trimId }) {
            /**
             * Fired when clicked on the trim item
             *
             * @event click
             * @type {object}
             * @property {object} $event - Click event
             * @property {object} id - Item trimId
             */
            this.$emit('trim-click', trimId);
        },
    },
};
</script>
